module.exports = __webpack_public_path__ + "img/health12_7-9-2021.9c00306f.jpg";